import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export const useClaimOrder = ({
  orderId,
  onSuccess,
  onError,
}: {
  orderId: string;
  onSuccess: (userId: string) => void;
  onError: (error: Error) => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: (userId: string) =>
      OrdersClient.claimOrder(orderId, { userId }),
    onSuccess: (_, userId) => {
      onSuccess(userId);
    },
    onError: (error: Error) => {
      onError(error);
    },
  });

  return {
    claimOrder: mutate,
    isPending,
  };
};
